import React, { useState } from 'react';

import ItemsCarousel from 'react-items-carousel';
import classNames from 'classnames';

interface ISelectorWrapper<T> {
  children?: JSX.Element;
  data: Array<T>;
  extraElement?: () => JSX.Element;
  render: (record: T) => any;
  type?: string;
  isDonation?: boolean;
}
export default function SelectorWrapper<T>({
  children,
  data,
  extraElement,
  render,
  type,
  isDonation,
}: ISelectorWrapper<T>) {
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  const cardClassName = classNames(
    { 'scrollable-selector': !isDonation },
    { 'scrollable-donation-selector': isDonation },
  );

  const renderBaseItem = (
    element: JSX.Element,
    index: number,
    carousel: boolean,
  ): JSX.Element =>
    carousel ? (
      <div className={cardClassName + '-mobile__card'} key={index}>
        {element}
      </div>
    ) : (
      element
    );

  const renderItems = (
    carousel: boolean,
    extraElement?: () => JSX.Element,
  ): JSX.Element[] => {
    const baseElements = data?.map((el, i) =>
      renderBaseItem(render(el), i, carousel),
    );

    if (extraElement) {
      const extraItem = renderBaseItem(extraElement(), data.length, carousel);
      baseElements.push(extraItem);
    }

    return baseElements;
  };

  const donationContainerClassName = classNames(
    { 'checkout-selector-container': !isDonation },
    { 'checkout-donation-container': isDonation },
  );

  return (
    <div className={donationContainerClassName}>
      <div className={cardClassName + '-mobile show_only_mobile'}>
        {!isDonation && (
          <ItemsCarousel
            activeItemIndex={activeItemIndex}
            requestToChangeActive={setActiveItemIndex}
            infiniteLoop={type === 'product' || type === 'bundle'}
            numberOfCards={2}
            gutter={10}>
            {renderItems(true, extraElement)}
          </ItemsCarousel>
        )}
      </div>
      <div className={cardClassName + ' not_show_on_mobile'}>
        {renderItems(false, extraElement)}
      </div>
      <div className="scrollable-donation-selector-mobile show_only_mobile">
        {isDonation && renderItems(false, extraElement)}
      </div>
      {children}
    </div>
  );
}
